import styled from 'styled-components'

export const Root = styled.div``

export const Container = styled.div`
  padding: 0 1rem;
`
